import {useCallback, useEffect, useRef, useState} from 'react';

// null until the first measurement, so a caller can render at natural height until there is one to animate to
const useMeasuredHeight = () => {
    const [heightPx, setHeightPx] = useState(null);
    const observerRef = useRef(null);

    useEffect(() => () => observerRef.current?.disconnect(), []);

    const measuredRef = useCallback((element) => {
        observerRef.current?.disconnect();

        if (!element) return;

        observerRef.current = new ResizeObserver(() => setHeightPx(element.offsetHeight));
        observerRef.current.observe(element);

        setHeightPx(element.offsetHeight);
    }, []);

    return {measuredRef, heightPx};
};

export default useMeasuredHeight;
